/* eslint-disable no-shadow */
import React from 'react';
import PropTypes from 'prop-types';
import { favoritePlayerService } from 'general/js/services';
import QualLeaderboardPlayerRow from './qual-leaderboard-player-row';
import {
    renderColorState, renderColorStateHoles, renderRoundColorState
} from './actions/render-color-state';

import {
    DEFAULT_VIEW,
    HOLES_VIEW,
    QUALIFY_RESERVE_FLAG,
    TEE_START_POSITION,
    CLUB_NAME,
    FQ_HOLE,
    RQ_HOLE,
    R1,
    R2,
    ROUND_ONE,
    ROUND_TWO,
    TOTAL,
    IN,
    SCORE,
    TODAY,
    QUALIFIED_STATUS
} from './qual-leaderboard-const';
import { cellTypes, qualificationTypes } from './enums';
import QualLeaderboardRowTitle from './qual-leaderboard-row-title';
import {
    getPlayerFormattedTeeTimeByRound, getPlayerRoundById, getRoundParsById, renderRoundToPar, renderStartHoleByRoundId
} from './helpers/roundHelper';
import { renderClassName } from './helpers/utils';
import {
    clubNameView, fqHoleView,
    qualifiedReserveFlagView, qualifiedStatusView, rqHoleView, teeStartPositionView, totalViewField
} from './helpers/viewHelper';

const QualLeaderboardTable = (props) => {
    const tableWrapper = React.createRef();
    const arrowLeftRef = React.createRef();
    const arrowRightRef = React.createRef();
    const view = props.view;
    const processingState = props.processingState;
    const sortingHandler = props.sortingHandler;
    const players = props.players;
    let lastScroll = 0;
    let qualifyReserveFlag = false;
    let teeStartPosition = false;
    let r1 = false;
    let r2 = false;
    let qualifiedStatus = false;
    let finalQualificationHole = false;

    const initState = () => {
        if (view === DEFAULT_VIEW && props.options.type === qualificationTypes.FINAL) {
            r1 = true;
            r2 = true;
            finalQualificationHole = true;
        }

        players.forEach((player) => {
            if (view === DEFAULT_VIEW) {
                if (player[TEE_START_POSITION] && player[TEE_START_POSITION] !== '') {
                    teeStartPosition = true;
                }

                if (player[QUALIFY_RESERVE_FLAG]) {
                    qualifyReserveFlag = true;
                }

                if (player[QUALIFIED_STATUS]) {
                    qualifiedStatus = true;
                }
            }
        });
    };

    const classNameProps = {
        view,
        r1,
        r2,
        qualifyReserveFlag,
        teeStartPosition
    };

    const renderRoundField = (title, player, roundId) => {
        if (title) {
            return (
                <React.Fragment>
                    {roundId === ROUND_ONE && renderSortableField(cellTypes.R1, sortingHandler)}
                    {roundId === ROUND_TWO && renderSortableField(cellTypes.R2, sortingHandler)}
                </React.Fragment>
            );
        }

        const playerRound = getPlayerRoundById(player, roundId);
        let contentText = '-';
        let totalColorState = '';

        if (playerRound && playerRound.total) {
            contentText = playerRound.total;
        }

        if (playerRound && playerRound.total && playerRound.parSum) {
            totalColorState = renderRoundColorState(playerRound.total, playerRound.parSum);
        }

        return (
            <div className={`qual-leaderboard__cell qual-leaderboard__cell--r qual-leaderboard__cell--round-${roundId} ${totalColorState}`}>
                <div className="qual-leaderboard__content">
                    {contentText !== '-' ? contentText : `${getPlayerFormattedTeeTimeByRound(player, roundId)} ${renderStartHoleByRoundId(player, roundId)}`}
                </div>
            </div>
        );
    };

    const renderSortableField = (type, sortingHandler, inOutTotal) => {
        return (
            <QualLeaderboardRowTitle
                type={type}
                sortingHandler={sortingHandler}
                processingState={processingState}
                inOutTotal={inOutTotal}
            />
        );
    };

    const renderField = (field, title, player) => {
        field = field || '';
        title = title || false;
        const playerRound = getPlayerRoundById(player, props.selectedRoundId);
        const roundPars = getRoundParsById(props.location.roundPars, props.selectedRoundId);

        if (view === DEFAULT_VIEW) {
            if (field === CLUB_NAME) {
                return clubNameView(title, player);
            }

            if (field === TOTAL) {
                return totalViewField(title, player);
            }

            if (qualifyReserveFlag && field === QUALIFY_RESERVE_FLAG && !r1) {
                return qualifiedReserveFlagView(title, player);
            }

            if (qualifiedStatus && field === QUALIFIED_STATUS) {
                return qualifiedStatusView(title, player);
            }

            if (teeStartPosition && field === TEE_START_POSITION && !r1) {
                return teeStartPositionView(title, player);
            }

            if (finalQualificationHole && field === FQ_HOLE) {
                return fqHoleView(title, player);
            }

            if (!finalQualificationHole && field === RQ_HOLE) {
                return rqHoleView(title, player);
            }

            if (r1 && field === R1) {
                return renderRoundField(title, player, ROUND_ONE);
            }

            if (r2 && field === R2) {
                return renderRoundField(title, player, ROUND_TWO);
            }
        }

        if (view === HOLES_VIEW) {
            if (field === IN) {
                if (title) {
                    return (
                        <React.Fragment>
                            {props.selectedRoundId === ROUND_ONE && renderSortableField(cellTypes.R1_IN, sortingHandler, roundPars && roundPars.inTotal)}
                            {props.selectedRoundId === ROUND_TWO && renderSortableField(cellTypes.R2_IN, sortingHandler, roundPars && roundPars.inTotal)}
                        </React.Fragment>
                    );
                }

                return (
                    <div className="qual-leaderboard__cell qual-leaderboard__cell--in">
                        <div className="qual-leaderboard__content">{playerRound && playerRound.in}</div>
                    </div>
                );
            }

            if (field === SCORE) {
                if (title) {
                    return (
                        <React.Fragment>
                            {props.selectedRoundId === ROUND_ONE && renderSortableField(cellTypes.R1_SCORE, sortingHandler, roundPars && roundPars.parSum)}
                            {props.selectedRoundId === ROUND_TWO && renderSortableField(cellTypes.R2_SCORE, sortingHandler, roundPars && roundPars.parSum)}
                        </React.Fragment>
                    );
                }
                return (
                    <div className="qual-leaderboard__cell qual-leaderboard__cell--total">
                        <div className="qual-leaderboard__content">{playerRound && playerRound.total}</div>
                    </div>
                );
            }

            if (field === TODAY) {
                if (title) {
                    return (
                        <React.Fragment>
                            {props.selectedRoundId === ROUND_ONE && renderSortableField(cellTypes.R1_TO_PAR, sortingHandler)}
                            {props.selectedRoundId === ROUND_TWO && renderSortableField(cellTypes.R2_TO_PAR, sortingHandler)}
                        </React.Fragment>
                    );
                }

                return (
                    <div className="qual-leaderboard__cell qual-leaderboard__cell--today">
                        <div className="qual-leaderboard__content">
                            <div
                                className={`qual-leaderboard__content-style ${renderColorState(playerRound.roundToPar, 'today')}`}>
                                {renderRoundToPar(playerRound.roundToPar)}
                            </div>
                        </div>
                    </div>
                );
            }
        }

        return null;
    };


    const createHolesField = () => {
        if (view === HOLES_VIEW) {
            const roundPars = getRoundParsById(props.location.roundPars, props.selectedRoundId);

            if (!roundPars || !Array.isArray(roundPars.holePars)) return null;

            return roundPars.holePars.map((hole, index) => {
                return (
                    <React.Fragment key={hole.holeNo}>
                        {
                            index === 9 && (
                                <React.Fragment>
                                    {props.selectedRoundId === ROUND_ONE && renderSortableField(cellTypes.R1_OUT, sortingHandler, roundPars && roundPars.outTotal)}
                                    {props.selectedRoundId === ROUND_TWO && renderSortableField(cellTypes.R2_OUT, sortingHandler, roundPars && roundPars.outTotal)}
                                </React.Fragment>
                            )
                        }
                        <div
                            key={hole.holeNo}
                            className="qual-leaderboard__cell qual-leaderboard__cell--title">
                            <div className="qual-leaderboard__cell-name">
                                <div>{hole.holeNo}</div>
                                <div className="qual-leaderboard__cell-name-par">{hole.par ? hole.par : '-'}</div>
                            </div>
                        </div>
                    </React.Fragment>
                );
            });
        }

        return null;
    };

    const getScoreByItemHole = (hole) => {
        return hole.score || '-';
    };

    const renderPlayerPar = (player) => {
        if (view === HOLES_VIEW) {
            const playerRound = getPlayerRoundById(player, props.selectedRoundId);

            //TODO: not stable, should go through locations round pars
            if (!playerRound || !Array.isArray(playerRound.holes)) return null;

            return playerRound.holes.map((hole, index) => {
                return (
                    <React.Fragment key={hole.holeNo}>
                        {
                            index === 9 && (
                                <div
                                    className="qual-leaderboard__cell qual-leaderboard__cell--out">
                                    <div className="qual-leaderboard__cell-name">{playerRound.out}</div>
                                </div>
                            )
                        }
                        <div
                            key={hole.holeNo}
                            className={`qual-leaderboard__cell qual-leaderboard__cell--score ${renderColorStateHoles(hole)}`}
                        >
                            {getScoreByItemHole(hole)}
                        </div>
                    </React.Fragment>
                );
            });
        }

        return null;
    };

    const onScrollLeftElement = (event) => {
        const scrollLeft = event.target.scrollLeft;
        const scrollWidth = event.target.scrollWidth;
        const offsetWidth = event.target.offsetWidth;

        if (scrollLeft === scrollWidth - offsetWidth) {
            arrowRightRef.current.classList.add('is-animation');
            tableWrapper.current.classList.add('is-animation');
        } else if (scrollLeft === 0) {
            arrowLeftRef.current.classList.remove('is-animation');
        } else if (scrollLeft > lastScroll) {
            arrowLeftRef.current.classList.add('is-animation');
        } else if (scrollLeft < lastScroll) {
            arrowRightRef.current.classList.remove('is-animation');
            tableWrapper.current.classList.remove('is-animation');
        }

        lastScroll = event.target.scrollLeft;
    };

    initState();


    return (
        <React.Fragment>
            <div
                className={`qual-leaderboard__table-wrapper ${renderClassName({ className: 'qual-leaderboard__table-wrapper', ...classNameProps })}`}
                ref={tableWrapper}
            >
                <div className="qual-leaderboard__arrows">
                    <div
                        className="qual-leaderboard__arrows-icon-wrapper qual-leaderboard__arrows-icon-wrapper--left"
                        ref={arrowLeftRef}
                    >
                        <svg className="qual-leaderboard__arrows-icon icon" width="10" height="10" focusable="false">
                            <use xlinkHref="#icon-arrow-down"></use>
                        </svg>
                    </div>

                    <div
                        className="qual-leaderboard__arrows-icon-wrapper qual-leaderboard__arrows-icon-wrapper--right"
                        ref={arrowRightRef}
                    >
                        <svg className="qual-leaderboard__arrows-icon icon" width="10" height="10" focusable="false">
                            <use xlinkHref="#icon-arrow-down"></use>
                        </svg>
                    </div>
                </div>

                <div
                    className="qual-leaderboard__wrapper"
                    onScroll={onScrollLeftElement}
                >
                    <div className={`qual-leaderboard__table ${renderClassName(classNameProps)}`}>
                        <div className="qual-leaderboard__row">
                            {renderSortableField(cellTypes.POSITION, sortingHandler)}
                            {renderSortableField(cellTypes.NATIONALITY, sortingHandler)}
                            {renderSortableField(cellTypes.PLAYER, sortingHandler)}

                            {renderField(QUALIFY_RESERVE_FLAG, true)}
                            {renderField(CLUB_NAME, true)}
                            {renderField(QUALIFIED_STATUS, true)}
                            {renderField(TEE_START_POSITION, true)}

                            {renderSortableField(cellTypes.PAR, sortingHandler)}
                            {createHolesField()}
                            {view === DEFAULT_VIEW && finalQualificationHole && renderSortableField(cellTypes.HOLE, sortingHandler)}
                            {r1 && renderSortableField(cellTypes.R1, sortingHandler)}
                            {r2 && renderSortableField(cellTypes.R2, sortingHandler)}
                            {view === DEFAULT_VIEW && renderSortableField(cellTypes.TOTAL, sortingHandler)}
                            {view === DEFAULT_VIEW && !finalQualificationHole && renderSortableField(cellTypes.HOLE, sortingHandler)}
                            {renderField(IN, true)}
                            {renderField(SCORE, true)}
                            {renderField(TODAY, true)}
                        </div>
                        <div className="qual-leaderboard__body">
                            {
                                players.map((player) => {
                                    const playerRound = getPlayerRoundById(player, props.selectedRoundId);
                                    const isFavorite = favoritePlayerService.isFavourite(player.entryId);

                                    if (!playerRound) return null;
                                    return (<QualLeaderboardPlayerRow
                                        key={player.entryId}
                                        player={player}
                                        renderField={renderField}
                                        renderPlayerPar={renderPlayerPar}
                                        renderColorState={renderColorState}
                                        isFavorite={isFavorite}
                                    />);
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

QualLeaderboardTable.propTypes = {
    options: PropTypes.object,
    location: PropTypes.object,
    selectedRoundId: PropTypes.string,
    view: PropTypes.string.isRequired
};

export default QualLeaderboardTable;
